module.exports = __webpack_public_path__ + "static/img/blueLogo.1232083b.png";